import { Component, OnInit } from '@angular/core';
import {AnalyticsService} from '../components/analytics-service/analytics.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss']
})
export class ContactComponent implements OnInit {

  lat: 47.5348526;
  lng: 7.6402213;
  constructor(private analyticsService: AnalyticsService) {
    this.analyticsService.emitEvent(
      'Page visit',
      'Contact'
    );
  }
  ngOnInit() {
  }

}
